<template>
	<div>
		<el-dialog :close-on-click-modal="false" title="新增" :visible.sync="dialogVisible" width="30%"
			:before-close="handleClose" @open="open">
			<div>
				<el-form :model="form" :rules="rules" ref="roleForm" label-width="100px">
					<el-form-item label="權限等級" prop="parent_id">
						<el-select ref="selectTree" v-model="form.parent_id" placeholder="請選擇" style="width: 100%;">
							<el-option :key="form.parent_id" :value="form.parent_id" :label="form.parent_name" hidden>

							</el-option>
							<el-tree style="width: 100%;" ref="tree" :data="ruleList" :props="defaultProps"
								node-key="id" accordion highlight-current @node-click="handleNodeClick" />
						</el-select>
					</el-form-item>
					<el-form-item label="類型" prop="type">
						<el-radio v-model="form.type" :label="1">菜單</el-radio>
						<el-radio v-model="form.type" :label="2">方法</el-radio>
					</el-form-item>
					<el-form-item label="權限名稱" prop="rule_name">
						<el-input v-model="form.rule_name" placeholder="請輸入"></el-input>
					</el-form-item>
					<el-form-item label="模塊" prop="module">
						<el-input v-model="form.module" placeholder="請輸入"></el-input>
					</el-form-item>
					<el-form-item label="控制器" prop="controller">
						<el-input v-model="form.controller" placeholder="請輸入"></el-input>
					</el-form-item>
					<el-form-item label="方法" prop="action">
						<el-input v-model="form.action" placeholder="請輸入"></el-input>
					</el-form-item>
					<el-form-item label="權限路徑" prop="path">
						<el-input v-model="form.path" placeholder="請輸入"></el-input>
					</el-form-item>
					<el-form-item label="權限代碼" prop="node">
						<el-input v-model="form.node" placeholder="請輸入"></el-input>
					</el-form-item>
					<el-form-item label="輸入圖標" prop="icon">
						<el-input v-model="form.icon" placeholder="請輸入">
							<el-link slot="append" href="https://element.eleme.cn/#/zh-CN/component/icon"
								target="_blank">在线选取圖標</el-link>
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				selectNode: '',
				form: {
					parent_id: 0,
					parent_name: "第一層選單",
					type:1,
					module:"",
					controller:'',
					action:"",
					rule_name: "",
					node:"",
					path: "",
					icon: "",
					sort: 0
				},
				ruleList: [],
				rules: {
					rule_name: [{
						required: true,
						message: "權限名稱不能为空",
						trigger: "blur"
					}],
				},
				defaultProps: {
					children: 'children',
					label: 'rule_name'
				},
			}
		},
		created() {

		},
		methods: {
			submit() {
				this.$refs.roleForm.validate((valid) => {
					if (valid) {
						this.$request({
							url: this.$api.rules.create,
							method: "post",
							data: this.form
						}).then((res) => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.$refs.roleForm.resetFields();
								this.$emit("success");
							} else {
								this.$message.error(res.data.msg)
							}
						}).catch(() => {
							this.$message.error("请求失败");
						})
					} else {
						return false;
					}
				})

			},
			handleNodeClick(data, checked) {
				if (checked) {
					this.$refs.tree.setCheckedNodes([data])
					this.selectNode = data
					this.form.parent_id = data.id;
					this.form.parent_name = data.rule_name;


					// 使 input 失去焦点，并隐藏下拉框
					this.$refs.selectTree.blur()
				}
			},
			//dialog打开时
			open(){
				this.getRuleList();
			},
			getRuleList() {
				this.$request({
					url: this.$api.rules.getAllRuleList,
				}).then((res) => {
					let first = [{
						children: [],
						create_at: "2022-10-25 00:00:00",
						icon: null,
						id: 0,
						levels: 1,
						parent_id: 0,
						type:1,
						module:"",
						controller:'',
						action:"",
						path: "",
						rule_name: "一级菜单",
						sort: 0,
						status: 1,
						update_at: null,
						_level: 0,
					}];
					this.ruleList = [...first, ...res.data.data];
				})
			},
			handleClose() {
				this.$emit("close");
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/rule/RuleCreateModal.vue